<template>
  <div class="online-bookingForm">
    <search-form :display-submit-button="true" type="online_search"
                 v-model="formData" :submit-callbacks="submitCallbacks"
                 :submit-button-text="submitButtonText"
    />
  </div>
</template>

<script>
import searchForm from '@/components/frontoffice/form/search'

export default {
  name: 'OnlineBookingForm',

  components: {
    searchForm
  },

  props: {
    submitCallbacks: Function,
    submitButtonText: String
  },

  computed: {
    formData () {
      return this.$store.getters['research/form']
    }
  }
}
</script>
